import type { SerializedError } from '@reduxjs/toolkit';

import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import initialConfig from '../initialConfig';

const initialState: {
  anonymous_citiesData: any;
  anonymous_citiesLoading: boolean;
  anonymous_citiesError: SerializedError | null;
} = {
  anonymous_citiesData: {},
  anonymous_citiesLoading: false,
  anonymous_citiesError: null,
};

export const anonymous_citiesFunc = createAsyncThunk(
  'anonymous_cities/anonymous_citiesFunc',
  async () => {
    const data1 = JSON.stringify({
      query: `query Anonymous_cities {
      anonymous_cities {
        data {
            name
            districts
        }
        count
      }
    }`,
    });

    const config = initialConfig(process.env.REACT_APP_BASE_URL_ACTIVITY || '', data1, '');

    const response = axios(config)
      .then((res) => {
        const data = res.data;
        return data;
      })
      .catch((err) => err);

    const data = await response;
    return data;
  }
);

const anonymous_cities = createSlice({
  name: 'anonymous_cities',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(anonymous_citiesFunc.pending, (state) => {
      state.anonymous_citiesLoading = true;
    });
    builder.addCase(anonymous_citiesFunc.fulfilled, (state, action) => {
      state.anonymous_citiesLoading = false;
      state.anonymous_citiesData = action.payload?.data?.anonymous_cities;
      state.anonymous_citiesError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(anonymous_citiesFunc.rejected, (state, action) => {
      state.anonymous_citiesLoading = false;
      state.anonymous_citiesError = action.error;
    });
  },
});

export default anonymous_cities.reducer;
